import { render, staticRenderFns } from "./createFilial.vue?vue&type=template&id=1af06d70&scoped=true&"
import script from "./createFilial.vue?vue&type=script&lang=js&"
export * from "./createFilial.vue?vue&type=script&lang=js&"
import style0 from "./createFilial.vue?vue&type=style&index=0&id=1af06d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af06d70",
  null
  
)

export default component.exports